import * as Yup from 'yup';
import { CampaignData, CampaignStatus } from '../models/campaign.ts';

export type UpdateStatusDto = {
    campaignId: string,
    status: CampaignStatus,
};

// deno-lint-ignore no-namespace
export namespace UpdateStatusDto {
    export function createValidation(): Yup.ObjectSchema<UpdateStatusDto> {
        return Yup.object({
            campaignId: Yup.string().required('Product is required'),
            status: Yup.mixed<CampaignStatus>().required('Type is required').oneOf(CampaignStatus.Helper.Values, 'Invalid type'),
        }).noUnknown();
    }
}

export type UpdateStatusResponseDto = {
    campaign: CampaignData;
};
